import { TimerMusicOutlineIcon } from './TimerMusicOutlineIcon';

/**
 * author: Colton Wiscombe
 * id CAEA0928-8B03-4139-B58F-DAD1865FDC12
 * name timer-music-outline
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-music-outline.svg
 * tags
 * - Date / Time 
 * - Music 
 */
export const StopwatchMusicOutlineIcon = TimerMusicOutlineIcon;
export default StopwatchMusicOutlineIcon